import { Injectable } from '@angular/core';
import {Observable, firstValueFrom} from "rxjs";
import {environment} from "../../../../environments/environment";
import {HttpClient, HttpParams} from "@angular/common/http";
import {CashInModel} from "./cashIn.model";
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CashInService {

  constructor(private http: HttpClient, private authService: AuthService) { }

  private url(path: string): string {
      const base =
        this.authService.getOriginCurrency() !== 'BRL'
          ? environment.intlUrl   
          : environment.apiUrl;

      return `${base}${path}`;
  }

  getEnum(): Promise<any> {
      const origin = this.authService.getOriginCurrency();
      let queryParams = new HttpParams();
      queryParams = queryParams.append('origin', origin);
  
      return firstValueFrom(
        this.http.get<any>(`${environment.apiUrl}/enum`, { params: queryParams })
      );
  }

  public sendDeposit(request : CashInModel) : Observable<any>
  {
    return this.http.post<any>(this.url('/deposit'), request);
  }


}
